module.exports = __webpack_public_path__ + "static/img/female-2.45b2bfe1.png";